const NXP = 'nxp'
const MAXIM = 'maxim'

const nxpObject = Object.freeze({
    type: NXP,
    label: NXP.toUpperCase(),
    required: true,
})

const maximObject = Object.freeze({
    type: MAXIM,
    label: MAXIM.toUpperCase(),
    required: false,
})

export default Object.freeze([nxpObject, maximObject])
